// VNEC v29 — BOD V2 cash wrapper (Cash & Liquidity)
// Loads /bod-v2-cash.html in iframe full-height
export function renderBodV2Cash() {
  return `<div style="width:100%;height:calc(100vh - 60px);margin:0;padding:0">
    <iframe src="/bod-v2-cash.html" style="width:100%;height:100%;border:none;display:block"></iframe>
  </div>`;
}
window.__pageInit = null;
